export enum GetInTouchPopupState {
  ageRestriction = 'ageRestriction',
  generalError = 'generalError'
}

export enum PopupStateNotes {
  Over85 = 'Over 85',
  Other = 'Other'
}

export interface GetInTouchPopupData {
  state: GetInTouchPopupState;
  message?: string;
}
